import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { ApiService } from 'src/app/core/services/api/api.service';
import { TemplateConfig } from 'src/app/models/template-config';

@Injectable({
  providedIn: 'root',
})
export class TemplateConfigService {
  getTemplateConfiguration(studyId: number, templateId: number, profileId: number): Observable<TemplateConfig> {
    return this.apiService.get<TemplateConfig>(
      `/dashboard/study/${studyId}/feedback/${templateId}/profile/${profileId}`
    );
  }

  saveTemplateConfiguration(config: TemplateConfig, studyId: number): Observable<void> {
    return this.apiService.post<void>(`/dashboard/study/${studyId}/feedback`, config);
  }

  constructor(private apiService: ApiService) {}
}
